(() => {
  function init(root = document) {
    root.querySelectorAll('[data-bundle-loop="true"]').forEach(slider => {
      if (slider.dataset.initialized) return;
      slider.dataset.initialized = 'true';
      const slides = [...slider.querySelectorAll('.slide')];
      if (slides.length < 2) return;
      const dots = slider.querySelector('.slide-dots');
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      let current = 0, timer, paused = reduced.matches;
      const pause = document.createElement('button');
      pause.type = 'button'; pause.className = 'bundle-pause';
      slider.appendChild(pause);
      function show(n) {
        current = (n + slides.length) % slides.length;
        slides.forEach((slide, i) => {
          slide.classList.toggle('active', i === current);
          slide.setAttribute('aria-hidden', String(i !== current));
          slide.querySelector('a').tabIndex = i === current ? 0 : -1;
          dots.children[i].classList.toggle('active', i === current);
          dots.children[i].setAttribute('aria-pressed', String(i === current));
        });
      }
      slides.forEach((_, i) => {
        const dot = document.createElement('button'); dot.type = 'button';
        dot.setAttribute('aria-label', `Show bundle image ${i + 1}`);
        dot.addEventListener('click', () => { show(i); restart(); }); dots.appendChild(dot);
      });
      function restart() {
        clearInterval(timer);
        pause.textContent = paused ? 'Play' : 'Pause';
        pause.setAttribute('aria-label', paused ? 'Play bundle slideshow' : 'Pause bundle slideshow');
        if (!paused && !document.hidden && !slider.querySelector(':focus-visible'))
          timer = setInterval(() => show(current + 1), Number(slider.dataset.speed) || 4000);
      }
      slider.querySelector('.slide-next').addEventListener('click', () => { show(current + 1); restart(); });
      slider.querySelector('.slide-prev').addEventListener('click', () => { show(current - 1); restart(); });
      pause.addEventListener('click', () => { paused = !paused; restart(); });
      slider.addEventListener('focusin', restart);
      slider.addEventListener('focusout', () => setTimeout(restart, 0));
      document.addEventListener('visibilitychange', restart);
      window.addEventListener('pageshow', () => {
        if (slider.contains(document.activeElement)) document.activeElement.blur();
        restart();
      });
      window.addEventListener('pagehide', () => clearInterval(timer));
      reduced.addEventListener('change', () => { paused = reduced.matches; restart(); });
      show(0); restart();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
